/**
 * installation-resources.js
 * ==========================
 * Click-to-load facade → YouTube iframe
 * Tab switching for multi-video products
 */

(function () {
  'use strict';

  var THUMB_SUFFIXES = ['maxresdefault', 'hqdefault', 'mqdefault', 'sddefault'];
  var MIN_THUMB_WIDTH = 320;

  function thumbSrc(videoId, suffix) {
    return 'https://i.ytimg.com/vi/' + videoId + '/' + suffix + '.jpg';
  }

  function buildIframeSrc(videoId) {
    return 'https://www.youtube.com/embed/' + videoId + '?rel=0&modestbranding=1&autoplay=1';
  }

  function bindVideoThumbnail(img, force) {
    if (!img) return;
    if (!force && img.dataset.iagThumbBound) return;

    var videoId = '';
    var srcMatch = (img.getAttribute('src') || '').match(/\/vi\/([^/]+)\//);
    if (srcMatch) videoId = srcMatch[1];

    if (!videoId) {
      var facade = img.closest('.iag-install-video-facade');
      if (facade && facade.dataset.videoId) videoId = facade.dataset.videoId;
    }

    if (!videoId) return;

    img.dataset.iagThumbBound = '1';
    img.loading = 'eager';
    img.decoding = 'async';

    function loadAt(index) {
      if (index >= THUMB_SUFFIXES.length) return;

      img.onload = function () {
        if (img.naturalWidth < MIN_THUMB_WIDTH && index + 1 < THUMB_SUFFIXES.length) {
          loadAt(index + 1);
        }
      };

      img.onerror = function () {
        if (index + 1 < THUMB_SUFFIXES.length) loadAt(index + 1);
      };

      img.src = thumbSrc(videoId, THUMB_SUFFIXES[index]);
    }

    loadAt(0);
  }

  function scanVideoThumbnails(root, force) {
    var scope = root || document;
    scope.querySelectorAll('.iag-install-video-facade__thumb').forEach(function (img) {
      bindVideoThumbnail(img, force);
    });
  }

  function observeProductAccordions() {
    document.querySelectorAll('.product__accordion details').forEach(function (details) {
      if (details.dataset.iagAccordionObserved) return;
      details.dataset.iagAccordionObserved = '1';

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'open' && details.open) {
            window.setTimeout(function () {
              scanVideoThumbnails(details, true);
            }, 500);
          }
        });
      }).observe(details, { attributes: true, attributeFilter: ['open'] });

      if (details.open) scanVideoThumbnails(details, true);
    });
  }

  function buildFacadeHTML(videoId, videoTitle) {
    var safeTitle = (videoTitle || '').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    var playBtn =
      '<svg viewBox="0 0 68 48" width="68" height="48">' +
        '<path d="M66.52 7.74C65.66 4.42 63.08 1.84 59.76.98 54.52-.06 34 0 34 0S13.48-.06 8.24.98C4.92 1.84 2.34 4.42 1.48 7.74.44 13 .44 24 .44 24s0 11 1.04 16.26c.86 3.32 3.44 5.9 6.76 6.76C13.48 48.06 34 48 34 48s20.52.06 25.76-.98c3.32-.86 5.9-3.44 6.76-6.76C67.56 35 67.56 24 67.56 24s0-11-1.04-16.26z" fill="#E8351A"/>' +
        '<polygon points="27,17 27,31 45,24" fill="#fff"/>' +
      '</svg>';

    return (
      '<img class="iag-install-video-facade__thumb"' +
        ' src="' + thumbSrc(videoId, 'maxresdefault') + '"' +
        ' alt="' + safeTitle + '"' +
        ' width="1280" height="720" loading="eager">' +
      '<span class="iag-install-video-facade__play" aria-hidden="true">' + playBtn + '</span>' +
      '<span class="iag-install-video-facade__title">' + safeTitle + '</span>'
    );
  }

  // ── Load video: swap facade contents with iframe ───────────────
  // Keeps the .iag-install-video-facade wrapper in the DOM so it
  // retains its width/aspect-ratio, just replaces its children.
  function loadVideo(facade) {
    var videoId    = facade.dataset.videoId;
    var videoTitle = facade.dataset.videoTitle || '';
    if (!videoId) return;

    // Remove click cursor now that video is playing
    facade.style.cursor = 'default';
    facade.removeAttribute('role');
    facade.removeAttribute('tabindex');

    // Build and insert iframe as the only child
    var iframe = document.createElement('iframe');
    iframe.src             = buildIframeSrc(videoId);
    iframe.title           = videoTitle;
    iframe.allow           = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.loading         = 'eager';
    // Fill the facade container completely
    iframe.style.cssText   = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;';

    facade.innerHTML = '';
    facade.appendChild(iframe);
  }

  // ── Tab switch: reset facade for new video ─────────────────────
  function activateTab(tabEl) {
    var tabsWrapper = tabEl.closest('[data-video-tabs]');
    if (!tabsWrapper) return;

    var videoId    = tabEl.dataset.videoId    || '';
    var videoTitle = tabEl.dataset.videoTitle || '';

    // Update tab states
    tabsWrapper.querySelectorAll('.iag-install-video-tabs__tab').forEach(function (t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    tabEl.classList.add('is-active');
    tabEl.setAttribute('aria-selected', 'true');

    // Find the player facade and reset it
    var facade = tabsWrapper.querySelector('.iag-install-video-facade');
    if (!facade) return;

    facade.dataset.videoId    = videoId;
    facade.dataset.videoTitle = videoTitle;
    facade.setAttribute('role', 'button');
    facade.setAttribute('tabindex', '0');
    facade.setAttribute('aria-label', 'Play ' + videoTitle);
    facade.style.cursor = 'pointer';
    facade.innerHTML = buildFacadeHTML(videoId, videoTitle);
    scanVideoThumbnails(facade, true);
  }

  // ── Event delegation ───────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var facade = e.target.closest('.iag-install-video-facade[role="button"]');
    if (facade) { loadVideo(facade); return; }

    var tab = e.target.closest('.iag-install-video-tabs__tab');
    if (tab) { activateTab(tab); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var facade = e.target.closest('.iag-install-video-facade[role="button"]');
    if (facade) { e.preventDefault(); loadVideo(facade); return; }
    var tab = e.target.closest('.iag-install-video-tabs__tab');
    if (tab) { e.preventDefault(); activateTab(tab); }
  });

  scanVideoThumbnails();
  observeProductAccordions();

  var thumbObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        scanVideoThumbnails(node);
        observeProductAccordions();
      });
    });
  });

  thumbObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.product__accordion summary');
    if (!summary) return;

    var details = summary.closest('details');
    if (!details) return;

    window.setTimeout(function () {
      if (details.open) scanVideoThumbnails(details, true);
    }, 500);
  });

  document.addEventListener('accordion:open', function (event) {
    scanVideoThumbnails(event.target || document, true);
  });

  document.addEventListener('on:accordion:open', function (event) {
    scanVideoThumbnails(event.target || document, true);
  });

  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.open) scanVideoThumbnails(event.target, true);
  }, true);

})();
